import React from "react";
import "./Map.css";

export default function Map() {
  return (
    <div className="map">
      <h1 className="textCenter">Location</h1>
      <h2 className="textCenter">Find Us On Google Map</h2>
      <iframe
        title="location"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4898.398652139849!2d12.543376474261308!3d41.909452559951625!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf7282552fbaaca28!2sMadani%20School%20And%20College!5e0!3m2!1sen!2sbd!4v1615302957146!5m2!1sen!2sbd"
        width="100%"
        height="450"
        style={{ border: 0, borderRadius: "8px", overflow: "hidden" }}
        allowFullScreen={false}
        loading="lazy"
      ></iframe>
    </div>
  );
}
